import { Dispatch, SetStateAction } from 'react';

import { classNames } from '~/lib';
import { Heading } from '../Heading';
import { ArticleCard } from './ArticleCard';
import { MobileCategoryNav } from './MobileCategoryNav';

interface LatestArticlesProps {
  title?: string;
  featuredItems?: any[];
  categories?: string[];
  category?: string;
  setCategory?: Dispatch<SetStateAction<string>>;
}

export const LatestArticles = ({
  title,
  featuredItems,
  categories,
  category,
  setCategory,
}: LatestArticlesProps) => {
  return (
    <>
      <Heading variant="h4" as="h2" className="w-full mt-18 md:mt-16">
        {title}
      </Heading>

      <div className="relative mt-6 md:hidden">
        <MobileCategoryNav
          category={category}
          setCategory={setCategory}
          categories={categories}
        />
      </div>

      <div className="hidden md:flex mt-10">
        <button
          className={classNames(
            'py-2 px-4 text-grey-700 rounded-lg',
            category === 'all' ? 'shadow-sm' : 'opacity-60',
          )}
          onClick={() => setCategory('all')}
        >
          View all
        </button>
        {categories?.map((cat, i) => (
          <button
            key={i}
            className={classNames(
              'py-2 px-4 text-grey-700 rounded-lg',
              category === cat ? 'shadow-sm' : 'opacity-60',
            )}
            onClick={() => setCategory(cat)}
          >
            {cat}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-y-14 md:gap-y-0 md:gap-x-4 lg:gap-x-12 mt-12">
        {featuredItems?.map((article) => (
          <ArticleCard key={article?.uuid} article={article} />
        ))}
      </div>
    </>
  );
};
